<template>
  <div>
    <h4>Supplier Filter</h4>
    <el-card>
      <el-form-item label="Designated">
        <el-checkbox v-model="checkSupplierAll">ALL</el-checkbox>
        <transition name="fade">
        <div v-show="!checkSupplierAll">
          <div>
            <el-button size="mini" type="primary" @click="addNewLine">+ Add Line</el-button>
            <el-button
              size="mini"
              type="warning"
              plain
              :disabled="!lineSelected"
              @click="handleDelete"
            >Delete Line</el-button>
          </div>
          <el-table
            ref="multipleTable"
            :row-style="{height:'36px'}"
            :style="{width:'396px'}"
            border
            stripe
            size="small"
            :header-cell-style="{background:'#D7D7D7',color:'#000'}"
            @selection-change="handleSelectionChange"
            :data="suppliers"
            :row-key="(row)=>row.id"
          >
            <el-table-column type="selection" width="50" align="center"></el-table-column>
            <el-table-column type="index" width="45" align="center"></el-table-column>
            <el-table-column label="Supplier Name" width="300">
              <template v-slot="scope">
                <ReportSupplierDesignate :rowId="scope.row.id" />
              </template>
            </el-table-column>
          </el-table>
        </div>
        </transition>
      </el-form-item>
    </el-card>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import ReportSupplierDesignate from './ReportSupplierDesignate'

export default {
  name: 'ReportSupplier',
  components: {
    ReportSupplierDesignate
  },
  data () {
    return {
      lineSelected: false
    }
  },
  computed: {
    ...mapState('report', [
      'supplierAll',
      'selectedSuppliers'
    ]),
    checkSupplierAll: {
      get () {
        return this.supplierAll
      },
      set (val) {
        this.setSupplierAll(val)
      }
    },
    suppliers: {
      get () {
        return this.selectedSuppliers
      }
    }
  },
  methods: {
    ...mapMutations({
      addNewLine: 'report/addNewSupplierLine',
      setSupplierAll: 'report/setSupplierAll',
      deleteSupplier: 'report/deleteSupplier'
    }),
    handleSelectionChange (selection) {
      this.lineSelected = selection.length > 0
    },
    handleDelete () {
      const ids = this.$refs.multipleTable.selection.map(sel => sel.id)
      if (ids.length === 0) {
        return
      }
      ids.forEach(i => this.deleteSupplier(i))
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
</style>
